import { Box, Tooltip } from '@mantine/core';
import { IconLock } from '@tabler/icons-react';
import ActionIcon from 'components/ActionIcon';

interface RepeatCreationLabelProps {
  label: string;
  locked: boolean;
  onToggle: () => void;
  withinPortal: boolean;
  required?: boolean;
}

/** Labels an input with its repeat-creation retention toggle. */
export default function RepeatCreationLabel({
  label,
  locked,
  onToggle,
  withinPortal,
  required = false,
}: RepeatCreationLabelProps) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      {required ? (
        <span>
          {label}
          <Box
            component="span"
            aria-hidden
            sx={(theme) => ({ color: theme.fn.variant({ variant: 'filled', color: 'red' }).background })}
          >
            {' *'}
          </Box>
        </span>
      ) : (
        label
      )}
      <Tooltip
        label={
          locked
            ? 'Hodnota sa po vytvorení zachová. Kliknutím odomknete.'
            : 'Hodnota sa po vytvorení obnoví na predvolenú. Kliknutím uzamknete.'
        }
        withinPortal={withinPortal}
        openDelay={300}
        multiline
        width={240}
        events={{ hover: true, focus: true, touch: false }}
      >
        <ActionIcon
          component="span"
          role="button"
          tabIndex={0}
          size="xs"
          variant={locked ? 'subtle' : 'subtle-gray'}
          sx={(theme) =>
            locked
              ? {}
              : {
                  color: theme.colors.gray[4],
                  '&:hover, &:focus': { color: theme.colors.gray[5] },
                }
          }
          aria-label={`Zachovať hodnotu: ${label}`}
          aria-pressed={locked}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              event.stopPropagation();
              onToggle();
            }
          }}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onToggle();
          }}
        >
          <IconLock size={16} stroke={locked ? 2.5 : 1.5} aria-hidden />
        </ActionIcon>
      </Tooltip>
    </span>
  );
}
